-- | App-level messages consumed by the runtime/update loop.
module App.Msg
    ( Msg(..)
    ) where

import Prelude (Unit)

import Data.Either (Either)
import Data.Maybe (Maybe)
import API.Document (FormReport, ToggleLockResult)
import API.Pagination (Page)
import API.RecentForms (RecentForm)
import API.Signature (SigVerification)
import API.Types (DocumentID)
import Error (ErrorWrapper)
import Form.StudentSelect as StudentSelect
import App.Operation.Types (OperationId, OperationKind)
import App.State (AppState)
import Routing.PushState (LocationState)
import Steps.Step1.State (RecentFormState) as Step1
import Steps.Step1.Update (DocExport, Msg, UpdateFormsSelection) as Step1
import Steps.FormPicker as FormPicker
import Steps.Step3.State (Step3State)
import Steps.Step3.Update as Step3
import Steps.WorkQueue.Cache (WorkQueuePreloadResult)
import Widgets.UpdateForm (FormsResponseDummy)

data Msg
    = BrowserLocationChanged LocationState
    | HydratedLocation Int LocationState (Either ErrorWrapper AppState)
    | Step1Msg Step1.Msg
    | Step1SearchDebounced Int
    | Step1InitialLoaded OperationId (Either ErrorWrapper Step1.RecentFormState)
    | Step1RecentFormsLoaded OperationId (Either ErrorWrapper (Page RecentForm))
    | Step1FormOrderSaved OperationId (Either ErrorWrapper FormPicker.FormPickerState)
    | Step1LocksToggled OperationId (Either ErrorWrapper (Array ToggleLockResult))
    | Step1DocumentsCopied OperationId (Either ErrorWrapper (Array DocumentID))
    | Step1DocumentsDeleted OperationId (Either ErrorWrapper Unit)
    | Step1DocumentsExported OperationId Step1.DocExport (Either ErrorWrapper (Array FormReport))
    | Step1SignaturesRequested OperationId (Either ErrorWrapper (Array SigVerification))
    | Step1FormsUpdated OperationId Step1.UpdateFormsSelection (Either ErrorWrapper FormsResponseDummy)
    | Step2AAction StudentSelect.SelectStudentStepAction
    | Step2AInitialLoaded OperationId (Either ErrorWrapper StudentSelect.SelectStudentState)
    | Step2BAction FormPicker.FormPickerAction
    | Step2BLoaded OperationId (Either ErrorWrapper FormPicker.FormPickerState)
    | Step2FormsExported OperationId (Either ErrorWrapper (Array FormReport))
    | Step3Msg Step3.Msg
    | Step3DocumentRequestHandled
    | Step3FormTypesLoaded OperationId (Either ErrorWrapper WorkQueuePreloadResult)
    | Step3InitialLoaded OperationId (Either ErrorWrapper Step3State)
    | OpStarted OperationId OperationKind (Maybe Int)
    | OpCompleted OperationId
    | OpFailed OperationId ErrorWrapper
    | OpSuperseded OperationId
